// Slide-in animation constants
export const STAGGER_DELAY = 12;
export const ANIMATION_START_FRAME = 10;

// Flip animation constants
export const FLIP_START_DELAY = 30;
export const FLIP_STAGGER_DELAY = 8;

// Phase transition constants
export const PHASE_1_MAX_CARDS = 3;
export const PHASE_FLIP_TO_HOLD_BUFFER = 20;
export const HOLD_DURATION = 40;
export const EXIT_DURATION = 25;

// Category transition gap (frames between categories)
export const CATEGORY_TRANSITION_GAP = 10;

// Fixed sizes for card elements (in pixels)
export const NOTCH_RADIUS = 24;
export const NOTCH_OFFSET = 42;
export const DOT_SIZE = 36;

// Extra height from the project label overflow
export const PROJECT_LABEL_OVERFLOW = 52;

// Maximum number of cards to display per phase
export const MAX_CARD_DISPLAY = 5;
